import { Observable } from "rxjs"
import { customAjax } from "../components/ErrorHandler"
import { baseURL } from "./ServiceUtil"
import { CommunityFeedbackOptions } from "../models/CommunityFeedback"

export const getCommunityFeedbackOptions = (id: number): Observable<CommunityFeedbackOptions> => {
    return customAjax(`${baseURL}/community_feedback/${id}`, 'OPTIONS');
  }
  